import { Form } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';

import { FilterContainerProps } from './props';
import { Container } from './styles';

const FilterContainer: React.FC<FilterContainerProps> = ({ onFilter, children, initialValues }) => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const [formFilter] = Form.useForm();

  useEffect(() => {
    formFilter.resetFields();
  }, [inscricaoAtiva, cddAtivo, formFilter]);

  return (
    <Container
      form={formFilter}
      layout="vertical"
      onFinish={onFilter}
      initialValues={initialValues}
    >
      {children}
    </Container>
  );
};

export default FilterContainer;
